
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, ButtonBase, } from '@material-ui/core';

class MatchChooseItem extends React.Component {

    constructor(props) {
        super(props); 
        this.state = {
            value: 0,
        };
    }

    _handleChange(val) {
        this.setState({ value: val });
    }

    render() {
        const { classes, data, selected } = this.props;
        let styles = {};
        if (selected) {
            styles = { background: '#007AFF' };
        } else {
            styles = { backgroundColor: '#EFEFF4' };
        }
        return (
            <ButtonBase className={classes.button} onClick={() => this.props.onClick && this.props.onClick(data)}>
                <Grid container direction='row' alignItems='center' justifyContent='space-between' className={classes.root} style={styles}>
                    <Typography noWrap={true} className={classes.contentText} style={{ color: selected ? '#FFF' : '#0D0D0D' }}>{data.short_name_zh}</Typography>
                    <Typography className={classes.subTitle} style={{ color: selected ? '#FFF' : '#878787' }}>{data.match_num + '场'}</Typography>
                </Grid>
            </ButtonBase>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        maxWidth: 106,
        height: 36,
        borderRadius: 10,
    },
    button: {
        width: '100%',
        height: '100%',
        maxWidth: 106,
        height: 36,
    },
    contentText: {
        color: '#FFFFFF',
        fontSize: 12,
        marginLeft: 8,
        maxWidth: 64,
    },
    subTitle: {
        color: '#FFFFFF',
        fontSize: 11,
        marginRight: 8,
    }
}))(MatchChooseItem));